import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const facilityRealtimeListeners: SocketEventListener[] = [
  {
    event: 'facilityChanged',
    handler: (msg: any) => {
      console.log('socket io - facilityChanged', msg);
      emitter.emit(EMITTER_CONSTANTS.FACILITY_CHANGED, msg);
    },
  },
  {
    event: 'FacilitySettingUpdated',
    handler: (msg: any) => {
      console.log('socket io - facilitySettingUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.FACILITY_SETTING_UPDATED, msg);
    },
  },
];

export default facilityRealtimeListeners;
